<template>
  <ion-img
      v-bind="$attrs"
      :src="props.logo.lightMode"
      alt="Logo"
      :class="['logo', size === 'lg' && 'logo--lg']"
  />
</template>

<script setup lang="ts">
import {IonImg} from '@ionic/vue';
import {Logo} from "@/models/settings.ts"

const props = defineProps<{
  logo: Logo;
  size?: 'lg';
}>();

defineOptions({
  inheritAttrs: false
});
</script>

<style scoped>
.logo {
  display: flex;
  align-items: flex-end;
  gap: 3px;
}

.logo        { width: 20px;  height: 22px; }
.logo--lg    { width: 100px;  height: 100px; }
</style>